// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"5c392921","126":"28adae59","453":"171ddc7f","696":"7b56bdea","774":"704e610c"}[chunkId] + ".chunk.js";
};